<template>
  <div :class="create ? 'form-wrap' : 'create-wrap'">
    <ul class="create-list" v-if="!create">
      <li @click="create='word'">内容：词汇</li>
      <li @click="create='grammar'">内容：语法</li>
      <li @click="create='sentence'">内容：例句 <span class="text-info">(仅华师大课程可用)</span></li>
      <li @click="create='kewen'">内容：课文</li>
      <li @click="create='exercise'">内容：题目</li>
      <li @click="handleCustom('iq_word')">自动出题：词汇 <span class="text-info">(仅华师大课程可用)</span> </li>
      <li @click="handleCustom('iq_words')">自动出题：词汇配对 <span class="text-info">(仅华师大课程可用)</span></li>
      <li @click="handleCustom('iq_writing')">自动出题：词汇书写 <span class="text-info">(仅华师大课程可用)</span></li>
      <li @click="handleCustom('iq_sentence')">自动出题：例句 <span class="text-info">(仅华师大课程可用)</span></li>
      <li @click="handleCustom('fy_word')">扉页：词汇</li>
      <li @click="handleCustom('fy_grammar')">扉页：语法</li>
      <li @click="handleCustom('fy_kewen')">扉页：课文</li>
      <li @click="handleCustom('fy_test')">扉页：小测试</li>
      <li @click="handleCustom('fy_training')">扉页：综合训练</li>
      <li @click="handleCustom('iq_repost')">错题重推 <span class="text-info">(仅华师大课程可用)</span></li>
      <li @click="handleCustom('ai_kewen')">AI强化课：课文回顾</li>
      <li @click="handleCustom('ai_words')">AI强化课：词汇练习</li>
      <li @click="handleCustom('ai_rc')">AI强化课：阅读理解</li>
      <li @click="handleCustom('ai_qa')">AI强化课：应用拓展 - 快速问答</li>
      <li @click="handleCustom('ai_topic')">AI强化课：应用拓展 - 话题讨论</li>
      <li @click="handleCustom('ai_rpg')">AI强化课：应用拓展 - 角色扮演</li>
    </ul>
    <div class="create-form-wrap" v-if="!!create">
      <component :is="create" ref="entity"></component>
      <el-row type="flex" justify="end" class="footer text-right">
        <el-button @click="create=null">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import kewen from './../../kewen/KewenForm'
import word from './../../word/WordForm'
import grammar from './../../grammar/GrammarForm'
import exercise from './../../exercise/ExerciseForm'
import sentence from '@/views/sentence/SentenceForm'

export default {
  name: 'LessonEntityCreate',
  components: { kewen, word, grammar, exercise, sentence },
  data () {
    return {
      create: null
    }
  },
  watch: {
    create(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.entity.reset({
            level: this.$store.state.teaching.level,
            num: this.$store.state.teaching.num,
          })
        })
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$emit('change', {
        type: this.create,
        entity: this.$refs.entity.getFormData()
      })
      this.create = null
    },
    handleCustom(type) {
      this.$emit('change', {
        type,
        entity: {id: 0}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .create-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  ul.create-list{
    border: 1px solid #eaeefb;
    border-left: 0;
    border-right: 0;
    list-style-type: none;
    overflow: hidden;
    padding: 0;
    text-align: left;
    flex: 1;
    > li{
      border-right: 1px solid #eee;
      border-bottom: 1px solid #eee;
      margin-right: -1px;
      margin-bottom: -1px;
      color: #606266;
      transition: background-color .15s linear;
      font-size: 16px;
      padding: 10px 15px;
      &:hover{
        cursor: pointer;
        color: white;
        background-color: #409EFF;
      }
    }
  }
</style>
